/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Statistic } from "./Statistic";
import {
  StatisticFromJSON,
  StatisticFromJSONTyped,
  StatisticToJSON,
  StatisticToJSONTyped,
} from "./Statistic";
import type { LabelCategory } from "./LabelCategory";
import {
  LabelCategoryFromJSON,
  LabelCategoryFromJSONTyped,
  LabelCategoryToJSON,
  LabelCategoryToJSONTyped,
} from "./LabelCategory";

/**
 *
 * @export
 * @interface MapResult
 */
export interface MapResult {
  /**
   *
   * @type {string}
   * @memberof MapResult
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof MapResult
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof MapResult
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof MapResult
   */
  calculatorType: string;
  /**
   *
   * @type {boolean}
   * @memberof MapResult
   */
  calculated: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MapResult
   */
  calculationSuccesful?: boolean;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof MapResult
   */
  legend?: { [key: string]: any } | null;
  /**
   *
   * @type {string}
   * @memberof MapResult
   */
  unit?: string;
  /**
   *
   * @type {string}
   * @memberof MapResult
   */
  geotiffUrl?: string;
  /**
   *
   * @type {boolean}
   * @memberof MapResult
   */
  showLegend?: boolean;
  /**
   *
   * @type {number}
   * @memberof MapResult
   */
  transparentValue?: number | null;
  /**
   *
   * @type {Array<Statistic>}
   * @memberof MapResult
   */
  statistics?: Array<Statistic> | null;
  /**
   *
   * @type {string}
   * @memberof MapResult
   */
  statisticTitle?: string | null;
  /**
   *
   * @type {string}
   * @memberof MapResult
   */
  labelPrimair?: string;
  /**
   *
   * @type {string}
   * @memberof MapResult
   */
  labelValue?: string;
  /**
   *
   * @type {string}
   * @memberof MapResult
   */
  labelType?: string;
  /**
   *
   * @type {string}
   * @memberof MapResult
   */
  labelDescription?: string;
  /**
   *
   * @type {Array<LabelCategory>}
   * @memberof MapResult
   */
  labelCategories?: Array<LabelCategory>;
  /**
   *
   * @type {Array<any>}
   * @memberof MapResult
   */
  percentages?: Array<any>;
}

/**
 * Check if a given object implements the MapResult interface.
 */
export function instanceOfMapResult(value: object): value is MapResult {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("description" in value) || value["description"] === undefined) return false;
  if (!("calculatorType" in value) || value["calculatorType"] === undefined) return false;
  if (!("calculated" in value) || value["calculated"] === undefined) return false;
  return true;
}

export function MapResultFromJSON(json: any): MapResult {
  return MapResultFromJSONTyped(json, false);
}

export function MapResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): MapResult {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    description: json["description"],
    calculatorType: json["calculator_type"],
    calculated: json["calculated"],
    calculationSuccesful:
      json["calculation_succesful"] == null ? undefined : json["calculation_succesful"],
    legend: json["legend"] == null ? undefined : json["legend"],
    unit: json["unit"] == null ? undefined : json["unit"],
    geotiffUrl: json["geotiff_url"] == null ? undefined : json["geotiff_url"],
    showLegend: json["show_legend"] == null ? undefined : json["show_legend"],
    transparentValue: json["transparent_value"] == null ? undefined : json["transparent_value"],
    statistics:
      json["statistics"] == null
        ? undefined
        : (json["statistics"] as Array<any>).map(StatisticFromJSON),
    statisticTitle: json["statistic_title"] == null ? undefined : json["statistic_title"],
    labelPrimair: json["label_primair"] == null ? undefined : json["label_primair"],
    labelValue: json["label_value"] == null ? undefined : json["label_value"],
    labelType: json["label_type"] == null ? undefined : json["label_type"],
    labelDescription: json["label_description"] == null ? undefined : json["label_description"],
    labelCategories:
      json["label_categories"] == null
        ? undefined
        : (json["label_categories"] as Array<any>).map(LabelCategoryFromJSON),
    percentages: json["percentages"] == null ? undefined : json["percentages"],
  };
}

export function MapResultToJSON(json: any): MapResult {
  return MapResultToJSONTyped(json, false);
}

export function MapResultToJSONTyped(
  value?: MapResult | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    name: value["name"],
    description: value["description"],
    calculator_type: value["calculatorType"],
    calculated: value["calculated"],
    calculation_succesful: value["calculationSuccesful"],
    legend: value["legend"],
    unit: value["unit"],
    geotiff_url: value["geotiffUrl"],
    show_legend: value["showLegend"],
    transparent_value: value["transparentValue"],
    statistics:
      value["statistics"] == null
        ? undefined
        : (value["statistics"] as Array<any>).map(StatisticToJSON),
    statistic_title: value["statisticTitle"],
    label_primair: value["labelPrimair"],
    label_value: value["labelValue"],
    label_type: value["labelType"],
    label_description: value["labelDescription"],
    label_categories:
      value["labelCategories"] == null
        ? undefined
        : (value["labelCategories"] as Array<any>).map(LabelCategoryToJSON),
    percentages: value["percentages"],
  };
}
